export const TEXT = {
  DELETE_ACCOUNT: 'Delete Account',
  DELETE_ACCOUNT_SUBTITLE:
    "We're sad to see you go! Before proceeding to delete, please note that you will lose access to the following:",
};

export const ICON_DIMENSION = {
  width: 40,
  height: 40,
};

export const ACCOUNT_DELETE_MENUS = [
  {
    title: 'Nykaa Fashion Wallets',
    subtitle: 'You will not be able to use balance in your Nykaa wallet',
    iconUrl: 'https://images-static.nykaa.com/uploads/0cfc4d36-52e6-4e54-be17-5620727a413d.png',
  },
  {
    title: 'Rewards',
    subtitle: 'You will not be able to use or redeem Reward Points',
    iconUrl: 'https://images-static.nykaa.com/uploads/4c151412-cd13-4273-9b80-2423ed0a76d6.png',
  },
  {
    title: 'Nykaa Fashion Accounts',
    subtitle:
      'Your account will no longer be accessible to use on any device and you cannot access order history',
    iconUrl: 'https://images-static.nykaa.com/uploads/a3a47164-6af7-4596-b5f8-f179a950eccc.png',
  },
];

export const DELETE_ACCOUNT_CTA = {
  DONT_WANT_TO_DELETE: 'No, I don’t want to delete',
  DELETE_ACCOUNT: 'Delete account',
};

export enum ACCOUNT_DELETE_SCREENS {
  INTENT_SCREEN = 'intentScreen',
  WENT_WRONG_SCREEN = 'wentWrongScreen',
  OTP_VERIFY_SCREEN = 'otpVerifyScreen',
  ERROR_SCREEN = 'errorScreen',
  GOODBYE_SCREEN = 'interMediateScreen',
  ORDER_ERROR_SCREEN = 'orderErrorScreen',
}

export const ACCOUNT_DELETE_REASONS = {
  header: {
    title: 'What went wrong?',
  },
  body: [
    {
      title: 'No Relevant Products',
      subtitle: 'I didn’t find the products I was looking for',
      fieldName: 'noRelevantProduct',
    },
    {
      title: 'Not Satisfied',
      subtitle: "I am not happy with Nykaa's service",
      fieldName: 'unSatisfactoryService',
    },
    {
      title: 'Spam & Notifications',
      subtitle: 'Was receiving too many daily updates',
      fieldName: 'spamAndNotification',
    },
  ],
  footer: {
    primaryActionTitle: 'Proceed',
    secondaryActionTitle: 'Cancel',
  },
};

export const GOODBYE_SCREEN_TEXT = {
  title: "This isn't goodbye",
  subtitle: 'You can come back to us anytime you want!',
  iconUrl: 'https://images-static.nykaa.com/uploads/ab4e12b8-309d-4b46-841d-0f7231081d72.png',
  redirectionPrefixText: 'redirecting in ',
  redirectInSec: 5,
  width: 360,
  height: 720,
};

export const ORDER_ERROR_SCREEN_TEXT = {
  OOPS: 'Oops!',
  ACTIVE_ORDER: 'Since you have an active order you cannot delete your account.',
  IMAGE_URL: 'https://images-static.nykaa.com/uploads/2ab993fc-ad72-45c6-afc7-615c89e6cdcd.png',
  WIDTH: 264,
  HEIGHT: 198,
};

export const OTP_VERIFY_SCREEN_TEXT = {
  TITLE: 'Verify OTP',
  SUBTITLE: 'Enter the six digit OTP sent to your  mobile no.: ',
  MOBILE_STD_PREFIX: '+91 ',
  TIMER_PREFIX: 'Resend OTP in ',
  TIMER_SUFFIX: ' Sec',
  CONFIRM_DELETE_ACCOUNT: 'Confirm, delete my account',
  RETRY_LABEL: 'Retry',
  RESEND_LABEL: 'Resend OTP',
  EXCEEDED_RESEND_LIMIT: 'Your attempts to verify OTP has exceeded.',
};

export interface InputFieldsSelected {
  noRelevantProduct: boolean;
  unSatisfactoryService: boolean;
  spamAndNotification: boolean;
  [key: string]: boolean;
}

export const FALLBACK_ERROR = 'Something went wrong!';
export const OVERLAY_MARGIN = 11;

export enum SCREEN_FLOW {
  BACK = 'back',
  FORWARD = 'forward',
}

export const OTP_LENGTH = 6;

export const ALERT_ICON_SIZE = '18px';
export const OTP_MAX_TIME_ALLOWED = 45;

export const ONE_SECOND = 1000;

export const ACCOUNT_DELETE_EVENTS = {
  DELETE_ACCOUNT_PAGE_LOADS: 'delete_account_page_loads',
  DELETE_ACCOUNT_PAGE_INTERACTIONS: 'delete_account_page_interactions',
  DELETE_ACCOUNT_ACTIVE_ORDER: 'delete_account_active_order',
  ACCOUNT_DELETE_SUCCESSFULLY: 'account_deleted_successfully',
};

export enum TEXT_CTAS {
  CANCEL = 'cancel',
  PROCEED = 'proceed',
  DELETE_ACCOUNT = 'delete account',
  NO_DONT_DELETE_ACCOUNT = "no, i don't want to delete",
  CONFIRM = 'confirm',
  DELETE_MY_ACCOUNT = 'delete my account',
}
export const ARIA_LABEL = {
  HOME: 'Home',
};
